import { likedFolderService } from '../../api';

import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKey } from '../../constant';

/**
 * 서랍을 가져오는 훅
 */
export const useGetFolders = () => {
  const { data, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: queryKey.getInfiniteLikeFolders,
    queryFn: ({ pageParam }) => likedFolderService.get({ last_sno: pageParam }),
    initialPageParam: undefined as number | undefined,
    select: data => {
      return data.pages.flatMap(page => page.folders);
    },
    getNextPageParam: lastPage => {
      const folders = lastPage.folders;
      const lastIdx = folders.length - 1;

      if (folders.length < 20 || lastIdx === -1) {
        return undefined;
      }
      return folders[19].sno;
    },
    staleTime: 0,
    gcTime: 0,
  });

  return {
    folders: data,
    getNextFolders: fetchNextPage,
    hasNextPage,
  };
};
